module.exports = __webpack_public_path__ + "quicksilver/static/media/kotak.88264a72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/kotak.svg
// module id = 644
// module chunks = 0